import { fromJS } from "immutable"
import { GET_SYNCHRONIZATIONS_FAILED, GET_SYNCHRONIZATIONS_SUCCESS, GET_SYNCHRONIZATIONS_WATCHER } from "./constants"


export const initialState = fromJS({
    isLoadingSynchronizations: false,
    synchronizations: []
})

function synchronizationReducer(state = initialState, action) {
    switch (action.type) {
        case GET_SYNCHRONIZATIONS_WATCHER:
            return state.set("isLoadingSynchronizations", true)
        case GET_SYNCHRONIZATIONS_SUCCESS:
            return state.set("synchronizations", action.payload).set("isLoadingSynchronizations", false)
        case GET_SYNCHRONIZATIONS_FAILED:
            return state.set("synchronizations", []).set("isLoadingSynchronizations", false)
        default:
            return state
    }
}

export default synchronizationReducer
